<template>
  <div class="patients-selector-network-error__container">
    <div class="mb-4">{{ $t('patients_selector.network_error') }}</div>
    <div>
      <v-btn depressed color="primary" :disabled="loading" @click="retry">
        <v-icon left>
          mdi-refresh
        </v-icon>
        {{ $t('patients_selector.retry') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientsSelectorNetworkError',
  props: ['retry', 'loading'],
};
</script>

<style>
.patients-selector-network-error__container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
